import CategoryContainer from "./Category.Container";

export default CategoryContainer;